import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import $ from 'jquery'
import moment from 'moment'
import { ElementVariableDto } from '../../../dto/GenApi.iNotPaie.Dto/ElementVariableDto';
import { ContratElementVariableDto } from '../../../dto/GenApi.iNotPaie.Dto/ContratElementVariableDto';
import { ParametresInstance } from '../../Controls/Parameters';
import { ServicesFactoryInstance } from '../../Controls/ServicesFactory';

interface dateChoisissable {
    date?: Date;
    libelle: string;
}

@Component
export default class ModalRecapAllVariables extends Vue {
    contrats?: ContratElementVariableDto[] = undefined;
    libelleContrat? = "";

    annuler() {
        $('#modalRecapAllVariables').modal('hide');
    }

    checkContrats(): boolean {
        return this.contrats != undefined;
    }

    getDetails(contrats: ContratElementVariableDto[]) {
        this.contrats = contrats;
        this.libelleContrat = "Prévisualisation des variables saisies";
        this.$forceUpdate();
    }

    downloadPdf() {
        if (this.contrats != undefined)
            ServicesFactoryInstance.VariablesService.generatePDF(this.contrats, data => {
                this.download(data);
            })
    }

    download(r: Blob) {
        const link = document.createElement("a");
        document.body.appendChild(link);

        link.href = window.URL.createObjectURL(r);
        link.download = "VARIABLES SAISIES CONTRAT.pdf";
        link.click();
    }
}





// WEBPACK FOOTER //
// ./src/components/saisieDesVariables/modalRecapAllVariables/modalRecapAllVariables.ts